import { axios, createFormData, handleError } from '../axios';

export const memberRemoveComment = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post('member/comment/remove', createFormData(data))
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
